export const Footer = () => (
  <footer
    style={{
      borderTop: '1px solid #2a3354',
      padding: '2rem 0',
      marginTop: '3rem',
    }}
  >
    <div
      style={{
        maxWidth: '72rem',
        margin: '0 auto',
        padding: '0 1rem',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <p
          style={{
            fontSize: '0.875rem',
            color: '#8b92a8',
            marginBottom: '1rem',
          }}
        >
          Join the Syscoin community
        </p>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '2rem',
            flexWrap: 'wrap',
          }}
        >
          <a
            href="https://x.com/syscoin"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '0.875rem',
              color: '#81C784',
              textDecoration: 'none',
            }}
          >
            X (Twitter)
          </a>
          <a
            href="https://discord.com/invite/syscoin"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '0.875rem',
              color: '#81C784',
              textDecoration: 'none',
            }}
          >
            Discord
          </a>
          <a
            href="https://t.me/SyscoinES"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '0.875rem',
              color: '#81C784',
              textDecoration: 'none',
            }}
          >
            Telegram (Hispano)
          </a>
        </div>
      </div>
    </div>
  </footer>
);

